import {
    Heading,
    Stack,
    Text,
    ThemeColorVariable,
    ThemeFontSizeVariable,
    ThemeSpaceVariable,
} from "@caspeco/casper-ui-library";
import { SafeHTML } from "components/safe-html";
import { WebRule } from "types/web-rule";

interface SimpleWebRulesTitleProps {
    webRule: WebRule;
}

/**
 * Simple component for displaying comment-only webRules
 * Used when a webRule has a comment but no bookable time slots
 * Supports HTML content including links, line breaks, tel: and mailto: URLs
 */
function SimpleWebRule({ webRule }: SimpleWebRulesTitleProps) {
    return (
        <Stack spacing={ThemeSpaceVariable.Small} data-testid={`simple-web-rule-${webRule.id}`}>
            <Heading
                as="h3"
                fontSize={ThemeFontSizeVariable.Large}
                color={ThemeColorVariable.OnBackgroundHeader}
                fontWeight={"medium"}
            >
                <SafeHTML element="span" html={webRule.title} />
            </Heading>
            {webRule.comment && (
                <Text
                    fontSize={ThemeFontSizeVariable.Medium}
                    color={ThemeColorVariable.OnSurfaceSubdued}
                >
                    <SafeHTML element="span" html={webRule.comment} />
                </Text>
            )}
        </Stack>
    );
}

export default SimpleWebRule;
